import React from 'react'

import { MenuItem, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  select: {
    margin: theme.spacing(2, 0),
  },
}))

const Select = ({ options = [], className, value, onChange, ...rest }) => {
  const classes = useStyles()
  return (
    <TextField
      select
      fullWidth
      value={value}
      variant="outlined"
      className={cn(className, classes.select)}
      onChange={(e) => onChange(e.target.value)}
      {...rest}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}

Select.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default Select
